import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { formatPrice } from 'utils/format';

import { Card, Typography } from '../base';
import CloudinaryPicture from './cloudinaryPicture';
import PriceBadge from './priceBadge';

const CategoryCard = forwardRef((props, ref) => {
  const className = classNames({
    'card-equalize': true,
    'card-category': true,
    [props.className]: props.className,
  });

  const price =
    props.category.prices.length > 0
      ? formatPrice(props.category.prices[0], props.category.currency)
      : null;

  return (
    <Card ref={ref} {...props} className={className}>
      <div className="card-img-top">
        <CloudinaryPicture imageKey={props.category.image} widths={props.widths} sizes={props.sizes} />
        {price && <PriceBadge prefix="Starting at">{price}</PriceBadge>}
      </div>
      <Card.Body>
        <Typography.H4 className="mb-0">
          <Typography.Span>{props.category.name}</Typography.Span>
        </Typography.H4>
      </Card.Body>
    </Card>
  );
});

CategoryCard.propTypes = {
  asLink: PropTypes.bool,
  category: PropTypes.object,
  className: PropTypes.string,
  children: PropTypes.node,
  // Forwarded to CloudinaryPicture; the caller knows the rendered layout (grid cols differ per page).
  widths: PropTypes.arrayOf(PropTypes.number),
  sizes: PropTypes.string,
};

CategoryCard.defaultProps = {
  asLink: false,
};

export default CategoryCard;
